<template>
  <div class="dashboard-container">
    <!-- Sales Modal -->
    <VueFinalModal
      v-model="showModal"
      :esc-to-close="true"
      @closed="closed"
      class="modal-container"
      content-class="modal-content2"
    >
      <div class="modal__content">
        <div class="modal-header-row">
          <div class="modal-title"></div>
          <div class="modal-close" @click="closed">
            <i
              class="fas fa-times-square close_modal"
              style="color: slategray"
            ></i>
          </div>
        </div>

        <form-venta
          v-if="showModal"
          :key="componentKeyFormVenta"
          :promo-code="promoCode"
          :token-auth="tokenAuth"
          :on-dashboard="true"
        />
      </div>
    </VueFinalModal>

    <!-- Withdraw Modal -->
    <VueFinalModal
      v-model="showModal2"
      :esc-to-close="true"
      @closed="closeWithdrawModal"
      class="modal-container"
      content-class="modal-content popupStyle"
      header-class="modal-header"
    >
      <div class="modal__content">
        <div class="modal-header-row">
          <div class="modal-title"></div>
          <div class="modal-close" @click="closeWithdrawModal">
            <i
              class="fas fa-times-square close_modal"
              style="color: slategray"
            />
          </div>
        </div>

        <retiro-cash
          v-if="showModal2"
          :key="componentKeyFormRetiro"
          :user-id="userId"
          :token-auth="tokenAuth"
          :user-bank-account-id="userBankAccountId"
          :close-withdraw-modal="closeWithdrawModal"
        />
      </div>
    </VueFinalModal>

    <!-- City Selection Modal -->
    <VueFinalModal
      v-model="showCityModal"
      :esc-to-close="false"
      class="modal-container"
      content-class="modal-content2"
    >
      <div class="modal__content">
        <div class="city-selection-container">
          <p class="text-center mb-4 titleYellowText">Selecciona tu Ciudad</p>
          <p class="city-selection-description">
            Para brindarte un mejor servicio, necesitamos saber tu ciudad
          </p>

          <div class="form-group">
            <select
              class="form-control-purple city-select"
              v-model="selectedCity"
              required
            >
              <option value="" disabled selected>Selecciona tu ciudad</option>
              <option v-for="city in sortedCities" :key="city" :value="city">
                {{ city }}
              </option>
            </select>
          </div>

          <div class="text-center mt-4">
            <button
              id="btnUpdateCity"
              type="button"
              class="btn btn-yellow-normal"
              :disabled="!selectedCity || isUpdatingCity"
              @click="updateUserCity"
            >
              Guardar Ciudad
            </button>
          </div>
        </div>
      </div>
    </VueFinalModal>

    <!-- Banner Modal -->
    <VueFinalModal
      v-model="showBannerModal"
      :esc-to-close="true"
      class="modal-container"
      content-class="modal-content2"
      @closed="closeBannerModal"
    >
      <div class="modal__content">
        <div class="modal-header-row">
          <div class="modal-title"></div>
          <div class="modal-close" @click="closeBannerModal">
            <i
              class="fas fa-times-square close_modal"
              style="color: slategray"
            ></i>
          </div>
        </div>
        <div class="banner-image-container">
          <img
            v-if="bannerData && bannerData.url"
            :src="bannerData.url"
            class="img-fluid banner-image"
            :alt="bannerData.title || 'Banner'"
          />
        </div>
      </div>
    </VueFinalModal>

    <div class="dashboard-content">
      <!-- Swiper section -->
      <div class="swiper-container">
        <swiper
          :slides-per-view="4"
          :space-between="15"
          :centered-slides="false"
          :navigation="false"
          :pagination="false"
          :breakpoints="{
            200: {
              slidesPerView: 1.1,
            },
            400: {
              slidesPerView: 1.1,
            },
            550: {
              slidesPerView: 2.5,
            },
            768: {
              slidesPerView: 3.1,
            },
            1024: {
              slidesPerView: 3.5,
            },
            1200: {
              slidesPerView: 4,
            },
          }"
        >
          <swiper-slide>
            <PresentMonthSales
              :key="componentKeySaldos"
              :user-id="userId"
              :token-auth="tokenAuth"
              :current-sales="currentSales"
              :loading-balance="loadingRecords"
            />
          </swiper-slide>
          <swiper-slide>
            <PendingSales
              :key="componentKeySaldos"
              :user-id="userId"
              :token-auth="tokenAuth"
              :pending-sales="pendingSales"
              :loading-balance="loadingRecords"
            />
          </swiper-slide>
          <swiper-slide>
            <PastMonthSales
              :key="componentKeySaldos"
              :user-id="userId"
              :token-auth="tokenAuth"
              :last-month-sales="lastMonthSales"
              :loading-balance="loadingRecords"
            />
          </swiper-slide>
          <swiper-slide>
            <HistoricalSales
              :key="componentKeySaldos"
              :user-id="userId"
              :token-auth="tokenAuth"
              :historical-sales="historicalSales"
              :loading-balance="loadingRecords"
            />
          </swiper-slide>
        </swiper>
      </div>

      <!-- Stats and Sales List section -->
      <div class="stats-and-sales-container">
        <div class="stats-container">
          <sales-stats
            :key="componentKeySalesStats"
            :user-id="userId"
            :token-auth="tokenAuth"
          />
        </div>
        <div class="sales-list-container">
          <listado-ventas-dashboard
            :key="componentKeyListadoVentas"
            :user-id="userId"
            :token-auth="tokenAuth"
            :onDashboard="true"
            :registerReferral="registerReferral"
          />
          <company-stats
            v-if="showCompanyStats"
            :user-id="userId"
            :token-auth="tokenAuth"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import Saldo from "./PresentMonthSales.vue";
import LinkReferido from "./LinkReferido.vue";
import LinkVenta from "./LinkVenta.vue";
import PendingSales from "./PendingSales.vue";
import PastMonthSales from "./PastMonthSales.vue";
import PresentMonthSales from "./PresentMonthSales.vue";
import HistoricalSales from "./HistoricalSales.vue";
import RegistroReferido from "./RegistroReferido.vue";
import ListadoVentasDashboard from "./ListadoVentasDashboard.vue";
import FormVenta from "../FormVenta";
import RetiroCash from "./RetiroCash.vue";
import SalesStats from "./SalesStats.vue";
import CompanyStats from "./CompanyStats.vue";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import WhatsappFloat from "../WhatsappFloat.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
export default {
  name: "dashboard-default",
  components: {
    Saldo,
    VueFinalModal,
    FormVenta,
    LinkReferido,
    LinkVenta,
    RegistroReferido,
    PastMonthSales,
    PresentMonthSales,
    HistoricalSales,
    ListadoVentasDashboard,
    RetiroCash,
    Swiper,
    SwiperSlide,
    PendingSales,
    WhatsappFloat,
    SalesStats,
    CompanyStats,
  },
  data() {
    let datos = this.$store.state.user;

    return {
      showModal: false,
      showModal2: false,
      showCityModal: false,
      showBannerModal: false,
      bannerData: null,
      selectedCity: "",
      isUpdatingCity: false,
      cities: [
        "Guayaquil",
        "Quito",
        "Cuenca",
        "Loja",
        "Santo Domingo",
        "Ambato",
        "Ibarra",
        "Portoviejo",
        "Riobamba",
        "Quevedo",
        "Latacunga",
        "Duran",
        "Pasaje",
        "Salinas",
        "La Libertad",
        "Azogues",
        "Manta",
        "Santa Rosa",
        "Babahoyo",
        "Tulcan",
        "Otavalo",
        "Montecristi",
        "Chone",
        "Cayambe",
        "Gualaceo",
        "Salcedo",
        "El Guabo",
        "Atuntaqui",
        "Huaquillas",
        "Piñas",
        "Cañar",
        "Machala",
        "Catamayo",
        "Jaramijo",
        "Cotacachi",
        "Arenillas",
        "Portovelo",
        "Calceta",
        "Alausi",
        "Tosagua",
        "Flavio Alfaro",
        "Camilo Ponce Enriquez",
        "Zaruma",
        "Balsas",
        "Chunchi",
        "Junin",
        "Cevallos",
        "Guamote",
        "Chaguarpamba",
        "Esmeraldas",
        "El Carmen",
      ],
      isMobile: this.$isMobile,
      loading: true,
      loadingRecords: true,
      historicalSales: 0,
      pendingSales: 0,
      currentSales: 0,
      lastMonthSales: 0,
      componentKeySaldos: 0,
      componentKeyMisVentas: 0,
      componentKeyPrimerNivel: 100,
      componentKeySegundoNivel: 200,
      componentKeyTercerNivel: 300,
      componentKeyListadoVentas: 400,
      componentKeyFormVenta: 500,
      componentKeyFormRetiro: 600,
      componentKeySalesStats: 700,
      promoCode: datos.promoCode,
      userId: datos.userId,
      displayName: datos.displayName,
      tokenAuth: this.$store.state.tokenAuth,
      userBankAccountId: datos.userBankAccountId,
      link:
        "Hola soy " +
        this.formatText(datos.names) +
        " " +
        datos.lastnames +
        " y te invito a formar parte de XTRIMPRO y ganar dinero refiriendo el internet de XTRIM, Regístrate en el siguiente link: www." +
        window.location.host +
        "/invitacion/" +
        datos.promoCode,
      helpText:
        "https://api.whatsapp.com/send?phone=593995756176&text=Hola,%20soy%20" +
        this.formatText(datos.namesList[0]) +
        " " +
        this.formatText(datos.lastnamesList[0]) +
        "%20y%20deseo%20obtener%20ayuda%20en%20XTRIMPRO",
      link1: "www." + window.location.host + "/invitacion/" + datos.promoCode,
    };
  },
  methods: {
    registerReferral() {
      this.$eventBus.emit("showModalVenta");
    },
    copyInputValue(model) {
      const inputElement = document.getElementById(model);
      inputElement.select();
      document.execCommand("copy");
      inputElement.setSelectionRange(0, 0);
      this.$toast.success("Link copiado exitosamente", {
        position: "top-right",
        max: 10,
      });
    },
    copyText() {
      if (this.isMobile) {
        if (navigator.share) {
          navigator
            .share({
              title:
                "XTRIMPRO - Link de referidos de" +
                this.formatText(this.namesList?.[0]) +
                " " +
                this.formatText(this.lastnamesList?.[0]),
              text:
                "Hola soy " +
                this.formatText(this.namesList?.[0]) +
                " " +
                this.formatText(this.lastnamesList?.[0]) +
                " y te invito a formar parte de XtrimPro y ganar dinero refiriendo el internet de Xtrim, Registrate en el siguiente link: ",
              url: "invitacion/" + this.promoCode,
            })
            .then(() => console.log("Successful share"))
            .catch((error) => console.log("Error sharing", error));
        }
      } else {
        // Copy the text inside the text field
        navigator.clipboard.writeText(this.link);

        this.$toast.success("Link Copiado exitosamente", {
          position: "top-right",
          max: 10,
        });
      }
    },
    closed() {
      this.$eventBus.emit("reiniciarFormVentaDashboard");
      this.showModal = false;
    },

    formatText(input) {
      return input.replace(
        /\b\w+/g,
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      );
    },

    closeWithdrawModal() {
      this.$eventBus.emit("ReiniciarRetiroCash");
      this.showModal2 = false;
    },
    copyInputValue(model) {
      const inputElement = document.getElementById(model);
      inputElement.select();
      document.execCommand("copy");
      inputElement.setSelectionRange(0, 0);
      this.$toast.success("Link Copiado exitosamente", {
        position: "top-right",
        max: 10,
      });
    },
    getBalances() {
      this.loadingRecords = true;
      this.$https
        .post("/sales/getUserSalesRecords/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((response) => {
          this.loadingRecords = false;
          // Usar valores por defecto (0) si no vienen en la respuesta
          this.historicalSales = response.data.historicalSales ?? 0;
          this.pendingSales = response.data.pendingSales ?? 0;
          this.currentSales = response.data.currentSales ?? 0;
          this.lastMonthSales = response.data.lastMonthSales ?? 0;
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else if (error.status === 404) {
            this.loadingRecords = false;
            return;
          } else {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
          }
          this.loadingRecords = false;
          // this.getReferidos();
        });
    },
    // Register event listeners
    registerEventListeners() {
      this.$eventBus.on(
        "reiniciarFormVentaDashboard",
        this.reiniciarFormVentaDashboard,
      );
      this.$eventBus.on("ReiniciarRetiroCash", this.ReiniciarRetiroCash);
      this.$eventBus.on("closeModalVenta", this.closeModalVenta);
      this.$eventBus.on("showModalVenta", this.showModalVenta);
      this.$eventBus.on("closeModalRetiro", this.closeModalRetiro);
      this.$eventBus.on("showModalRetiro", this.showModalRetiro);
      this.$eventBus.on("reiniciarListadoVentas", this.reiniciarListadoVentas);
      this.$eventBus.on("reiniciarSaldos", this.reiniciarSaldos);
    },
    // Remove event listeners
    removeEventListeners() {
      this.$eventBus.off(
        "reiniciarFormVentaDashboard",
        this.reiniciarFormVentaDashboard,
      );
      this.$eventBus.off("ReiniciarRetiroCash", this.ReiniciarRetiroCash);
      this.$eventBus.off("closeModalVenta", this.closeModalVenta);
      this.$eventBus.off("showModalVenta", this.showModalVenta);
      this.$eventBus.off("closeModalRetiro", this.closeModalRetiro);
      this.$eventBus.off("showModalRetiro", this.showModalRetiro);
      this.$eventBus.off("reiniciarListadoVentas", this.reiniciarListadoVentas);
      this.$eventBus.off("reiniciarSaldos", this.reiniciarSaldos);
    },

    // Event handler methods
    reiniciarFormVentaDashboard() {
      this.componentKeyFormVenta += 1;
    },
    ReiniciarRetiroCash() {
      this.componentKeyFormRetiro += 1;
    },
    closeModalVenta() {
      this.showModal = false;
    },
    showModalVenta() {
      this.showModal = true;
    },
    closeModalRetiro() {
      this.showModal2 = false;
    },
    showModalRetiro() {
      this.showModal2 = true;
    },
    reiniciarListadoVentas() {
      this.componentKeyListadoVentas += 1;
    },
    reiniciarSaldos() {
      this.getBalances();
    },
    updateUserCity() {
      if (!this.selectedCity) return;

      this.isUpdatingCity = true;
      document.getElementById("btnUpdateCity").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i>  Guardando...';

      this.$https
        .post("/profile/updateProfileCity/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          city: this.selectedCity,
        })
        .then((response) => {
          this.$store.commit("setUser", response.data.updatedProfile);
          this.showCityModal = false;
          this.$toast.success("Ciudad actualizada exitosamente", {
            position: "top-right",
            max: 10,
          });
        })
        .catch((error) => {
          if (error.response?.data?.code === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "login" });
          } else {
            this.$toast.error("Error al actualizar la ciudad", {
              position: "top-right",
              max: 10,
            });
          }
        })
        .finally(() => {
          this.isUpdatingCity = false;
          document.getElementById("btnUpdateCity").innerHTML = "Guardar Ciudad";
        });
    },

    checkUserCity() {
      const userData = this.$store.state.user;
      if (!userData.city) {
        this.showCityModal = false;
      }
    },
    closeBannerModal() {
      this.showBannerModal = false;
      // Store that banner has been shown in Vuex
      this.$store.dispatch("markBannerAsShown");
    },
    // async fetchBanner() {
    //   try {
    //     console.log("Fetching banner...");
    //     const response = await this.$https.post(
    //       "/access/getAvailableBannerTest",
    //       {
    //         tokenAuth: this.tokenAuth,
    //         userId: this.userId,
    //       },
    //     );
    //     console.log("Banner response:", response.data);

    //     if (response.data.code === 200 && response.data.banner) {
    //       this.bannerData = response.data.banner;
    //       // Only show banner if it hasn't been shown before
    //       if (!this.$store.state.bannerShown) {
    //         this.showBannerModal = true;
    //       }
    //     }
    //   } catch (error) {
    //     if (!this.$store.state.bannerShown) {
    //       console.log("Showing banner...");
    //       this.showBannerModal = false;
    //       this.$store.dispatch("markBannerAsShown");
    //     }
    //     console.error("Error fetching banner:", error);
    //   }
    // },
  },
  computed: {
    sortedCities() {
      return [...this.cities].sort((a, b) => a.localeCompare(b, "es"));
    },
    showCompanyStats() {
      const role = this.$store.state.user?.role;
      const type = this.$store.state.user?.type;
      return (role === "admin" || role === "director") && type === "enterprise";
    },
  },
  created() {},
  beforeUnmount() {},
  activated() {
    if (this.isMobile) {
      this.$eventBus.emit("activeShowMenu");
    }
  },
  deactivated() {
    console.log("About has been deactivated");
  },

  mounted() {
    // Register the event listeners when the component is mounted
    this.registerEventListeners();
    this.getBalances();
    this.checkUserCity();
    // this.fetchBanner();
  },
  beforeUnmount() {
    this.removeEventListeners();
  },
};
</script>

<style scoped>
.dashboard-container {
  width: 100%;
}

.dashboard-content {
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
}

.swiper-container {
  width: 100%;
}

.stats-and-sales-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.stats-container {
  flex: 1 1 300px;
  min-width: 300px;
}

.sales-list-container {
  flex: 3 1 600px;
  overflow: auto;
}

.modal-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.modal-title {
  flex-grow: 1;
}

.modal-close {
  cursor: pointer;
  padding: 8px;
}

.city-selection-container {
  width: 100%;
  padding: 0 15px;
}

.city-selection-description {
  font-size: 14px;
  color: white;
  font-weight: bold;
  text-align: center;
  margin-bottom: 12px;
  line-height: 15px;
}

.city-select {
  border: 2px solid #f9cc03;
  background: white;
}

.banner-image-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.banner-image {
  width: 100%;
  border-radius: 8px;
}

/* Original swiper styles */
.swiper {
  height: 100% !important;
}
.swiper-slide {
  height: auto !important;
}
.swiper-content {
  height: 100% !important;
}
.swiper-wrapper {
  align-items: stretch;
}

.pinkPurpleText {
  font-weight: 900;
  padding: 5px 10px;
  background: rgb(170, 50, 189);
  background: linear-gradient(
    68deg,
    rgba(170, 50, 189, 1) 0%,
    rgb(226, 80, 232) 100%
  );
  border: 2px solid #ec62ea;
  color: white;
  font-family: Ubuntu;
  margin: 0;
  width: 100%;
  border-radius: 16px;
  gap: 8px;
  margin: 8px 0;
  box-shadow: 0px 2px 10px 2px #bc49be48;
  font-size: 18px;
  text-align: center;
}
.pinkPurpleText:hover {
  background: linear-gradient(
    68deg,
    rgb(226, 80, 232) 0%,
    rgba(170, 50, 189, 1) 100%
  );
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Apply the animation to the image */
.rotating-image {
  animation: rotate 2s linear infinite; /* Adjust duration and timing */
}

.titleYellowText {
  text-align: center;
  font-family: Ubuntu;
  color: #7d0c7e;
  font-size: 14px;
  text-shadow:
    2px 2px 0px white,
    -2px -2px 0px white,
    2px -2px 0px white,
    -2px 2px 0px white;
  background: #f9cc03;
  border-radius: 12px;
  padding: 3px 12px;
  box-shadow: 0px 2px 10px 2px #7c0c7e48;
  width: fit-content;
  margin: 0 auto;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .stats-and-sales-container {
    gap: 0;
    flex-direction: column;
  }

  .stats-container,
  .sales-list-container {
    width: 100%;
  }

  /* Remove flex properties for stats container on mobile */
  .stats-container {
    flex: none;
    min-width: unset;
    /* margin-bottom: 20px; */
  }
}
</style>
